import { QUESTIONS } from "../constants/questions";
import { StarRatingQuestion } from "./starRatingQuestion";

interface Props {
  companyName: string;
  ratings: Record<string, number>;
  onChange: (id: string, value: number) => void;
}

export function RatingsCard({ companyName, ratings, onChange }: Props) {
  return (
    <div class="tl-card">
      {QUESTIONS.map((q, i) => (
        <StarRatingQuestion
          key={q.id}
          index={i + 1}
          question={q}
          companyName={companyName}
          value={ratings[q.id] || 0}
          onChange={(v) => onChange(q.id, v)}
        />
      ))}
    </div>
  );
}
